import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "pane", "tab", "completionYear", "table", "helpText"
  ]

  connect() {}

  switchTab(event) {
    const selected = event.currentTarget.dataset.tab

    this.tabTargets.forEach(tab => {
      tab.classList.toggle("active", tab.dataset.tab === selected)
    })

    this.paneTargets.forEach(pane => {
      pane.style.display =
        pane.dataset.pane === selected ? "block" : "none"
    })

    if (this.hasHelpTextTarget) {
      if (selected === "projectpart") {
        this.helpTextTarget.textContent =
          "枝番は同一事業内で重複不可です。"
      }

      if (selected === "projectwage") {
        this.helpTextTarget.textContent =
          "同一「事業×手当」で期間重複は不可。改定は複製→開始日変更が便利です。"
      }
    }
  }

  edit(event) {
    if (this.hasTableTarget) {
      this.tableTarget.querySelectorAll(".btn.active").forEach(btn => {
        btn.classList.remove("active")
      })
    }
    event.currentTarget.classList.add("active")

    const badge = this.tableTarget.querySelector("span.badge")
    const row = event.currentTarget.closest("tr")
    const actionCell = row.children[row.children.length - 1]

    if (badge && actionCell) {
      actionCell.append(badge)
    }

    const breadcrumb = document.getElementById("breadcrumb")
    const projectName = row.dataset.projectName

    if (breadcrumb && projectName) {
      breadcrumb.textContent = `マスタ ＞ 事業 ＞ ${projectName}`
    }

    const allowIdBadge = document.getElementById("allowIdBadge")
    const projectId = row.dataset.projectId

    if (allowIdBadge && projectId) {
      allowIdBadge.textContent = `事業ID： ${projectId}`
    }
  }
}
